import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import ServicePage from './pages/ServicePage';
import './styles/global.css';
import './styles/app.css';
import ProductPage from './pages/ProductPage';
import ContactPage from './pages/ContactPage';
import ManufacturingPage from './pages/ManufacturingPage';

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product/:slug" element={<ProductDetailsPage />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/engineering-services" element={<ServicePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/manufacturing" element={<ManufacturingPage />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
